/**
 * @description Available hex codes for account colour preference in the app
 */
export enum ColourHexCode {
    Blue = '#006dff',
    Purple = '#6e3aff',
    Teal = '#00a897',
    Orange = '#ff471f',
    Pink = '#ff365c',
}

/**
 * @description Readable name for account colour preference in the app
 */
type ColourName = 'client-blue' | 'client-purple' | 'client-teal' | 'client-orange' | 'client-pink'

/**
 * @description Constant defining available account colour selections with readable name
 */
export const Colours: { name: ColourName; hex: ColourHexCode }[] = [
    {
        name: 'client-teal',
        hex: ColourHexCode.Teal,
    },
    {
        name: 'client-blue',
        hex: ColourHexCode.Blue,
    },
    {
        name: 'client-purple',
        hex: ColourHexCode.Purple,
    },
    {
        name: 'client-pink',
        hex: ColourHexCode.Pink,
    },
    {
        name: 'client-orange',
        hex: ColourHexCode.Orange,
    },
]
